export default __webpack_public_path__ + "static/media/large.c18d59cf.jpg";